import React from 'react';

import styled from 'styled-components';

import { LinkNoDecoration } from 'components/app-header/mobile-header/styled';
import Picture from 'components/picture';
import { useFeatureNavigation } from 'hooks/use-feature-navigation';
import { primitive } from 'styles/constants/primitives';

const StyledPicture = styled(Picture)`
  width: 24px;
`;

const HamburgerContainer = styled.div`
  margin: ${primitive.$spacing3} ${primitive.$spacing0};
  position: fixed;
`;

export const HamburgerButton: React.FC = () => {
  const { featureNavigationMobileHeaderButton } = useFeatureNavigation();

  return featureNavigationMobileHeaderButton ? (
    <HamburgerContainer>
      <LinkNoDecoration to={featureNavigationMobileHeaderButton?.link?.locale ?? ''}>
        <StyledPicture image={featureNavigationMobileHeaderButton?.icon?.locale} alt="icon" />
      </LinkNoDecoration>
    </HamburgerContainer>
  ) : null;
};
